import axios from '@/axios'

export const getFaceToken = params =>
  axios.post('/amp/app/1.0/getFaceToken', params)
export const faceVerify = params =>
  axios.post('/amp/app/1.0/faceVerify', params)
